import { ICategoryChartParams } from '../chartUtils'

export interface IBasePieChartConfigParams extends ICategoryChartParams {
  center?: boolean
  valueLabel?: string
  title?: string
  graphType?: string
}

export const STANDARD_PALETTE = [
  '#82ACFF',
  '#55C390',
  '#1F355E',
  '#24B4E9',
  '#84C441',
  '#427EC3',
  '#A7A9AC',
  '#94C9C7',
  '#4193C4',
  '#808285',
  '#426F5A'
]

// These value should be the same as acceptance categories colors
export const RISK_THRESHOLD_PALETTE = [
  '#51AD3E', // Low
  '#C4D146', // Medium - Low
  '#EEB242', // Medium
  '#DD7139', // Medium - High
  '#BF3438' // High
]
